import { deserialize, deserializeAs, inheritSerialization } from 'cerialize';
import { Entity } from './entity';

@inheritSerialization(Entity)
export class Dpe extends Entity {

  @deserializeAs('etiquette_energetique')
  etiquetteEnergetique;

  @deserializeAs('etiquette_environnementale')
  etiquetteEnvironnementale;
}
